import { trpc } from '@tencent/tpro_rmonitor_user_manager_user_role_auth';
import { Modal, Input, Radio, message, RadioChangeEvent } from 'antd';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BusiCode } from '@/infrastructure/axios/code';
import { applyCreate, getAllRoles } from '@/presentation/pages/product/permission/api';
import { WithTypeCast } from '@raft/utils';
import style from './../index.module.scss';

type IRole = WithTypeCast<trpc.rmonitor.user_manager.IRole>;

const { TextArea } = Input;

interface PropsType {
  permissionDialogVisible: boolean;
  setPermissionDialogVisible: (value: boolean) => void;
  setSubmitDialogVisible: (value: boolean) => void;
  setIsSubmitResult: (value: string) => void;
}

export const SendPermission = (props: PropsType) => {
  const { t } = useTranslation();
  const {
    permissionDialogVisible,
    setPermissionDialogVisible,
    setSubmitDialogVisible,
    setIsSubmitResult,
  } = props;
  const [applyReason, setApplyReason] = useState('');
  const [applyType, setApplyType] = useState<number>();
  const [roleArr, setRoleArr] = useState<IRole[]>([]);

  const load = async () => {
    const data = await getAllRoles();

    setApplyType(data?.[0]?.id ?? undefined);
    setRoleArr(data);
  };

  useEffect(() => {
    load();
  }, []);

  const handleOk = async () => {
    if (!applyReason) {
      message.warning(t('未填写申请理由！'));
      return;
    }

    const res = await applyCreate({
      comment: applyReason,
      roleId: applyType,
    });
    if (res?.code === BusiCode.Ok) {
      setIsSubmitResult('succ');
    } else {
      setIsSubmitResult('fail');
    }
    setPermissionDialogVisible(false);
    setSubmitDialogVisible(true);
  };

  return <>
    <Modal
      title={t('申请权限')}
      visible={permissionDialogVisible}
      okText={t('发送申请')}
      onOk={handleOk}
      onCancel={() => setPermissionDialogVisible(false)}
    >
      <div className={style.dialogBox}>
        <TextArea
          placeholder={t('请输入申请理由（必填）')}
          autoSize={{ minRows: 6, maxRows: 6 }}
          value={applyReason}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setApplyReason(e.target.value)}
        />
      </div>
      <div className={style.dialogBox}>
        <span style={{ paddingRight: '8px' }}>{t('申请角色:')} </span>
        <Radio.Group
          onChange={(e: RadioChangeEvent) => setApplyType(e.target.value)}
          value={applyType}
        >
          {roleArr.map(role => (
            <Radio value={role.id}>{role.name}</Radio>
          ))}
        </Radio.Group>
      </div>
    </Modal>
  </>;
};
